<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
    <base-material-dialog
      :title='item.data === undefined ? "专利逾期信息" : "专利逾期信息" '
      :dialog="item.show"
      @on-dialog-change='dialogChange'
      persistent
      max-width='500'
      :fullscreen='$isMobile'
    >
      <template v-slot:content>
        <v-card class="px-5 py-5">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field label="逾期年度(逾期第几年年费)" outlined  :rules="number" hide-details="auto" v-model="form.year"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="年费金额" outlined  :rules="number" hide-details="auto" v-model="form.annualFee"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field label="滞纳金" outlined  :rules="number" hide-details="auto" v-model="form.overdueFee"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  v-model="dataSelect"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  hide-details="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      v-model="form.overdueEndtimeStr"
                      label="滞纳金截止时间"
                      :rules="required"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      hide-details="auto"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="zh-cn"
                    v-model="form.overdueEndtimeStr"
                    @input="dataSelect = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
             <v-row>
              <v-col cols="12" md="6">
                <v-text-field label="恢复费" outlined  :rules="number" hide-details="auto" v-model="form.recoveryFee"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  v-model="dataSelect"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  hide-details="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      v-model="form.recoveryEndtimeStr"
                      label="恢复费截止时间"
                      :rules="form.recoveryFee > 0 ? required : []"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      hide-details="auto"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="zh-cn"
                    v-model="form.recoveryEndtimeStr"
                    @input="dataSelect = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea rows='3' label="备注信息" outlined v-model="form.remark"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { save } from '@/api/patent/overdue.js'

  export default {
    name: 'Overdue',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        dataSelect: false,
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => (/^[0-9]+(.[0-9]{1,2})?$|^(0|[1-9][0-9]*)$/.test(value)) || `金额必填为数字`,
        ],
        form: {
          id: '',
          year: '',
          contractId: '',
          customerId: '',
          annualFee: 0,
          overdueFee: 0,
          recoveryFee: 0,
          overdueEndtime: '',
          recoveryEndtime: '',
          overdueEndtimeStr: '',
          recoveryEndtimeStr: '',
          remark: ''
        },
        defForm: {
          id: '',
          year: '',
          contractId: '',
          customerId: '',
          annualFee: 0,
          overdueFee: 0,
          recoveryFee: 0,
          overdueEndtime: '',
          recoveryEndtime: '',
          overdueEndtimeStr: '',
          recoveryEndtimeStr: '',
          remark: ''
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.form.overdueEndtime = new Date(this.form.overdueEndtimeStr).getTime() / 1000
          this.form.recoveryEndtime = new Date(this.form.recoveryEndtimeStr).getTime() / 1000
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          if (this.isEdit) {
            this.form = JSON.parse(JSON.stringify(this.item.data))
            this.form.year = this.item.data.yearCostNumber + 1
          }
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
        }
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined && this.item.data !== null
      }
    }
  }
</script>

<style>
</style>
